import { render, staticRenderFns } from "./drawlots-conf.vue?vue&type=template&id=562ebd86&scoped=true&"
import script from "./drawlots-conf.vue?vue&type=script&lang=js&"
export * from "./drawlots-conf.vue?vue&type=script&lang=js&"
import style0 from "./drawlots-conf.vue?vue&type=style&index=0&id=562ebd86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ebd86",
  null
  
)

export default component.exports